"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutTeaser() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -100px 0px"
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -100px 0px"
  });
  return <section id="aboutteaser" className="bg-background text-foreground py-24 md:py-32 lg:py-48 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-[84rem]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 order-2 lg:order-1 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.1] mb-8">
              I translate real-world value into digital authority.
            </h2>
            
            <div className="space-y-6 max-w-2xl">
              <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/90 font-light">
                You have already done the hard work of building something meaningful. My job is to ensure the internet actually knows it exists.
              </p>
              <p className="font-default text-lg md:text-xl leading-relaxed text-foreground/90 font-light">
                As a creative marketing consultant, I strip away the jargon and focus on what matters: getting you found, heard, and trusted by the right people. No fluff, just strategic visibility.
              </p>
            </div>

            <div className="mt-12">
              <Button asChild size="lg" className="px-8 py-6 text-base tracking-wide">
                <Link to="/AboutPage">
                  Read the Full Story
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 order-1 lg:order-2 transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
            <div className="relative w-full max-w-md mx-auto lg:max-w-none lg:ml-auto">
              <AspectRatio ratio={3 / 4} className="bg-muted/10 overflow-hidden">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/myles_dacres_abstract_portrait.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/myles_dacres_abstract_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722464/img/myles_dacres_abstract_portrait.png-wvc-sizes" alt="Abstract artistic portrait of Myles Dacres" className="object-cover w-full h-full grayscale contrast-125 mix-blend-luminosity opacity-90 hover:opacity-100 hover:scale-105 transition-all duration-700 ease-in-out" loading="lazy" />
              </AspectRatio>
              {}
              <div className="absolute -bottom-6 -left-6 w-24 h-[2px] bg-accent hidden md:block" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}